module.exports = __webpack_public_path__ + "static/scale-model-of-la-honda-winery-in-san-mateo-california-4e167078da8985f5ee0fa60da56e8d23.png";